import React from 'react';


class MiddleHeaderBs extends React.Component {

    render(){
        return (
			<div className="panel-header" style={{ background: "#F2F3F5"}}>
                <div className="page-inner py-5" style={{paddingTop: "0.5rem!important"}}>
                    <div className="d-flex align-items-left align-items-md-center flex-column flex-md-row">
                    </div>
                </div>
            </div>
        )}
};

export default MiddleHeaderBs;